import { motion } from "framer-motion";
import { ReactNode } from "react";

interface DynamicGradientProps {
  children?: ReactNode;
  className?: string;
  variant?: "primary" | "subtle" | "hero" | "secondary";
}

const DynamicGradient = ({ children, className = "", variant = "primary" }: DynamicGradientProps) => {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Floating orb 1 */}
      <motion.div
        className="absolute w-[500px] h-[500px] rounded-full opacity-20 blur-3xl pointer-events-none"
        style={{
          background: "radial-gradient(circle, hsl(355 100% 45% / 0.12), transparent 70%)",
          top: "-10%",
          left: "-10%",
        }}
        animate={{
          x: ["-5%", "10%", "-5%"],
          y: ["-5%", "15%", "-5%"],
        }}
        transition={{
          duration: 18,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      {/* Floating orb 2 */}
      <motion.div
        className="absolute w-[400px] h-[400px] rounded-full opacity-15 blur-3xl pointer-events-none"
        style={{
          background: "radial-gradient(circle, hsl(210 100% 15% / 0.15), transparent 70%)",
          bottom: "-10%",
          right: "-10%",
        }}
        animate={{
          x: ["10%", "-10%", "10%"],
          y: ["5%", "-15%", "5%"],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2,
        }}
      />

      {/* Content */}
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default DynamicGradient;
